import React from 'react';

const Radio = ({
  children,
  id,
  value,
  checked,
  disabled,
  className,
  analyticsKey,
  analyticsKey2,
  onChange
}) => {
  const combinedClassName = [
    'control',
    disabled ? 'control--disabled' : '',
    className
  ]
    .filter(x => x)
    .join(' ');
  return (
    <label className={combinedClassName}>
      <input
        type="radio"
        className="stat-radio"
        id={id}
        value={value}
        checked={checked}
        disabled={disabled}
        data-dtm={analyticsKey}
        data-dtm2={analyticsKey2}
        onChange={onChange}
      />
      <span className="control__indicator" />
      {children}
    </label>
  );
};

export default Radio;
